import { format } from 'date-fns'
import capitalize from 'lodash/capitalize'
import range from 'lodash/range'
import type { ComboboxItem } from './combobox'
import { Combobox } from './combobox'

interface Props {
  className?: string
  curtainClassName?: string
  id?: string

  value: number

  onChange(value: number): void
}

export function MonthCombobox({
  className,
  curtainClassName,
  id,

  value,

  onChange,
}: Props) {
  const months = range(12).map(month =>
    capitalize(format(new Date(1993, month, 1), 'LLLL'))
  )

  const monthOptions: ComboboxItem<number>[] = months.map((month, idx) => ({
    value: idx,
    label: month,
  }))

  return (
    <Combobox
      className={className}
      curtainClassName={curtainClassName}
      id={id}
      value={value}
      items={monthOptions}
      mode="single"
      noSearch
      onChange={onChange}
    />
  )
}
